<jw-modal id='orderAddGradeModal'>
  <h1 class='header'>Add Grade</h1>

  <div class='form-group'>
    @if (this.isError) {
      <div class="alert alert-danger">Please complete all required fields</div>
    }
    @if (this.isServerError) {
      <div class="alert alert-danger">Something went wrong. Please try again later.</div>
    }
    <div class='form-row col-md-4'>
      <label>Name</label>
      <input class='form-control' type='text' [(ngModel)]="this.grade.name" [class.is-invalid]='!this.grade.name'/>
    </div>
    <div class='form-row col-md-4'>
      <label>EWC Code (not required)</label>
      <input class='form-control' type='text' [(ngModel)]="this.grade.ewcCodes"/>
    </div>

  </div>
  <button type="submit" class="btn btn-success" (click)='this.onSubmit()'>Save</button>&nbsp;
  <button type="button" class="btn btn-danger" (click)='this.cancel()'>Cancel</button>
</jw-modal>
